/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useIsCurrentModal } from './context/currentModal/hooks';
import { useSetCurrentModalValue } from './context';
import { useCanCloseCurrentModal } from './context/canCloseModal';

const modalSkrimStyle: ouiStyle.InStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  lines: 'full',
  backgroundColor: ouiStyle.Constants.Colors.skrimShade,
  zIndex: 999994,
};

const modelaSkrimCss = () => ouiStyle.makeCss(modalSkrimStyle);

export const ModalSkrim = () => {
  const isOpen = !useIsCurrentModal(null);
  const canClose = useCanCloseCurrentModal();
  const closeModal = useSetCurrentModalValue(null, !canClose);

  return isOpen ? (
    <div
      css={modelaSkrimCss}
      onClick={closeModal}
    />
  ) : null;
};
